export const environment = {
  production: true,
  configFile: 'assets/config/arena.config.json',
  globalConfigFile: 'assets/config/global.config.json',
  systemConfigFile: 'assets/config/system.config.json',
  appConfigUrl: 'assets/config/app.config.json',
  webArenaConfigUrl: 'assets/config/arena.config.json',
};
